import type { RootState } from '@/store';

export const selectSituacoesArbitral = (state: RootState) => state.situacoesArbitral.items;
export const selectSituacoesArbitralLoading = (state: RootState) => state.situacoesArbitral.loading;
export const selectSituacoesArbitralSaving = (state: RootState) => state.situacoesArbitral.saving;
export const selectSituacoesArbitralError = (state: RootState) => state.situacoesArbitral.error;
export const selectEscritoriosSituacaoOpcoes = (state: RootState) =>
  state.situacoesArbitral.escritorios;
